<template>
    <div class="footer">
        <div class="footer-bg footer-bg_desktop">
            <svg width="1440" height="800" viewBox="0 0 1440 800" fill="none" xmlns="http://www.w3.org/2000/svg">
                <mask id="mask0_66_4372" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="1440"
                      height="800">
                    <rect x="1440" y="800" width="1440" height="800" transform="rotate(-180 1440 800)" fill="white"/>
                </mask>
                <g mask="url(#mask0_66_4372)">
                    <ellipse cx="720" cy="520" rx="1600" ry="400" fill="white"/>
                </g>
            </svg>
        </div>
        <div class="footer-bg footer-bg_mobile">
            <svg width="360" height="640" viewBox="0 0 360 640" fill="none" xmlns="http://www.w3.org/2000/svg">
                <mask id="mask0_66_7286" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="360"
                      height="640">
                    <rect x="360" y="640" width="360" height="640" transform="rotate(-180 360 640)" fill="white"/>
                </mask>
                <g mask="url(#mask0_66_7286)">
                    <ellipse cx="180" cy="431" rx="800" ry="400" fill="white"/>
                </g>
            </svg>
        </div>
        <div class="footer_block container">
            <div class="footer-logo">
                <footer-logo-img/>
            </div>
            <div class="footer_contacts">
                <a href="https://goo.gl/maps/wXKujP8KxWZk8bq38" target="_blank" class="footer_contacts--item">
                    <div class="icon icon-hide">
                        <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <g clip-path="url(#clip0_0_1315)">
                                <path d="M12.3594 12C11.2594 12 10.3594 11.1 10.3594 10C10.3594 8.9 11.2594 8 12.3594 8C13.4594 8 14.3594 8.9 14.3594 10C14.3594 11.1 13.4594 12 12.3594 12ZM18.3594 10.2C18.3594 6.57 15.7094 4 12.3594 4C9.00938 4 6.35938 6.57 6.35938 10.2C6.35938 12.54 8.30937 15.64 12.3594 19.34C16.4094 15.64 18.3594 12.54 18.3594 10.2ZM12.3594 2C16.5594 2 20.3594 5.22 20.3594 10.2C20.3594 13.52 17.6894 17.45 12.3594 22C7.02938 17.45 4.35938 13.52 4.35938 10.2C4.35938 5.22 8.15938 2 12.3594 2Z"
                                      fill="#015AB4"/>
                            </g>
                            <defs>
                                <clipPath id="clip0_0_1315">
                                    <rect width="24" height="24" fill="white" transform="translate(0.359375)"/>
                                </clipPath>
                            </defs>
                        </svg>
                    </div>
                    <div class="desc">
                        {{ $gettext('Україна, Київ, Бульварно-Кудрявська 37/14, оф. 307') }}
                    </div>
                </a>
                <a href="tel:+380667156372" target="_blank" class="footer_contacts--item">
                    <div class="icon">
                        <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <g clip-path="url(#clip0_0_1320)">
                                <path d="M20.3594 15.5C19.1094 15.5 17.9094 15.3 16.7894 14.93C16.6894 14.9 16.5794 14.88 16.4794 14.88C16.2194 14.88 15.9694 14.98 15.7694 15.17L13.5694 17.37C10.7394 15.93 8.41937 13.62 6.97937 10.79L9.17937 8.58C9.45937 8.31 9.53937 7.92 9.42937 7.57C9.05937 6.45 8.85938 5.25 8.85938 4C8.85938 3.45 8.40938 3 7.85938 3H4.35938C3.80937 3 3.35938 3.45 3.35938 4C3.35938 13.39 10.9694 21 20.3594 21C20.9094 21 21.3594 20.55 21.3594 20V16.5C21.3594 15.95 20.9094 15.5 20.3594 15.5ZM5.38938 5H6.88938C6.95938 5.88 7.10937 6.75 7.34937 7.59L6.14937 8.8C5.73937 7.59 5.47938 6.32 5.38938 5ZM19.3594 18.97C18.0394 18.88 16.7594 18.62 15.5594 18.21L16.7594 17.01C17.6094 17.25 18.4794 17.4 19.3594 17.46V18.97ZM12.3594 3V13L15.3594 10H21.3594V3H12.3594ZM19.3594 8H14.3594V5H19.3594V8Z"
                                      fill="#015AB4"/>
                            </g>
                            <defs>
                                <clipPath id="clip0_0_1320">
                                    <rect width="24" height="24" fill="white" transform="translate(0.359375)"/>
                                </clipPath>
                            </defs>
                        </svg>
                    </div>
                    <div class="desc">
                        +380 66 715 63 72
                    </div>
                </a>
                <a href="mailto:info@smtax.org.ua" target="_blank" class="footer_contacts--item">
                    <div class="icon">
                        <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <g clip-path="url(#clip0_0_1325)">
                                <path d="M12.3594 1.94995C6.83938 1.94995 2.35938 6.42995 2.35938 11.95C2.35938 17.47 6.83938 21.95 12.3594 21.95H17.3594V19.95H12.3594C8.01937 19.95 4.35938 16.29 4.35938 11.95C4.35938 7.60995 8.01937 3.94995 12.3594 3.94995C16.6994 3.94995 20.3594 7.60995 20.3594 11.95V13.38C20.3594 14.17 19.6494 14.95 18.8594 14.95C18.0694 14.95 17.3594 14.17 17.3594 13.38V11.95C17.3594 9.18995 15.1194 6.94995 12.3594 6.94995C9.59937 6.94995 7.35938 9.18995 7.35938 11.95C7.35938 14.71 9.59937 16.95 12.3594 16.95C13.7394 16.95 14.9994 16.39 15.8994 15.48C16.5494 16.37 17.6694 16.95 18.8594 16.95C20.8294 16.95 22.3594 15.35 22.3594 13.38V11.95C22.3594 6.42995 17.8794 1.94995 12.3594 1.94995ZM12.3594 14.95C10.6994 14.95 9.35938 13.61 9.35938 11.95C9.35938 10.29 10.6994 8.94995 12.3594 8.94995C14.0194 8.94995 15.3594 10.29 15.3594 11.95C15.3594 13.61 14.0194 14.95 12.3594 14.95Z"
                                      fill="#015AB4"/>
                            </g>
                            <defs>
                                <clipPath id="clip0_0_1325">
                                    <rect width="24" height="24" fill="white" transform="translate(0.359375)"/>
                                </clipPath>
                            </defs>
                        </svg>
                    </div>
                    <div class="desc">
                      info@smtax.org.ua
                    </div>
                </a>
            </div>
            <div class="footer_socials">
                <a href="https://www.facebook.com/SMTax.ua/" target="_blank">
                    <svg width="52" height="52" viewBox="0 0 52 52" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <rect x="52" y="52" width="52" height="52" rx="12" transform="rotate(-180 52 52)"
                              fill="#015AB4"/>
                        <path d="M31.9991 14.005L28.8868 14C25.3903 14 23.1307 16.3183 23.1307 19.9064V22.6297H20.0015C19.7311 22.6297 19.5121 22.8489 19.5121 23.1193V27.065C19.5121 27.3354 19.7313 27.5544 20.0015 27.5544H23.1307V37.5106C23.1307 37.781 23.3497 38 23.6201 38H27.7028C27.9732 38 28.1922 37.7808 28.1922 37.5106V27.5544H31.851C32.1214 27.5544 32.3404 27.3354 32.3404 27.065L32.3419 23.1193C32.3419 22.9895 32.2902 22.8651 32.1986 22.7733C32.107 22.6814 31.9821 22.6297 31.8523 22.6297H28.1922V20.3212C28.1922 19.2116 28.4566 18.6483 29.902 18.6483L31.9986 18.6475C32.2687 18.6475 32.4877 18.4283 32.4877 18.1582V14.4944C32.4877 14.2245 32.269 14.0055 31.9991 14.005Z"
                              fill="white"/>
                    </svg>
                </a>
                <a href="#">
                    <svg width="52" height="52" viewBox="0 0 52 52" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <rect x="52" y="52" width="52" height="52" rx="12" transform="rotate(-180 52 52)"
                              fill="#015AB4"/>
                        <g clip-path="url(#clip0_0_1335)">
                            <path d="M36.5635 15.7383C35.8654 15.1138 33.0731 13.0563 26.7905 13.0195C26.7905 13.0195 19.4056 12.5786 15.805 15.8853C13.7843 17.906 13.0862 20.8086 13.0127 24.4459C12.9392 28.0832 12.829 34.8802 19.4056 36.754V39.583C19.4056 39.583 19.3689 40.722 20.1037 40.9424C21.0222 41.2364 21.5366 40.3546 22.4183 39.4361C22.896 38.9217 23.5573 38.1869 24.0349 37.599C28.5173 37.9664 31.9709 37.1214 32.3751 36.9744C33.2936 36.6805 38.4005 36.0192 39.2456 29.2222C40.1273 22.168 38.8781 17.7223 36.5635 15.7383ZM37.335 28.6711C36.637 34.3659 32.4853 34.7333 31.7137 34.9537C31.3831 35.0639 28.3703 35.7987 24.5493 35.5783C24.5493 35.5783 21.7203 38.9952 20.8017 39.9137C20.6548 40.0607 20.5078 40.0974 20.3976 40.0974C20.2506 40.0607 20.2139 39.877 20.2139 39.6198C20.2139 39.2524 20.2506 34.917 20.2506 34.917C14.7028 33.3739 15.0335 27.5688 15.0702 24.5194C15.1437 21.4699 15.6948 19.0083 17.3849 17.3182C20.4343 14.5626 26.717 14.9668 26.717 14.9668C32.0076 15.0035 34.5427 16.5834 35.1306 17.1345C37.0411 18.8246 38.0331 22.8293 37.335 28.6711Z"
                                  fill="white"/>
                            <path fill-rule="evenodd" clip-rule="evenodd"
                                  d="M26.8819 22.0756C26.8923 21.8826 27.0572 21.7346 27.2502 21.745C27.9886 21.7849 28.5982 22.0081 29.0313 22.458C29.4624 22.9059 29.6724 23.5308 29.7119 24.2806C29.7221 24.4737 29.5738 24.6384 29.3808 24.6486C29.1878 24.6587 29.023 24.5105 29.0129 24.3174C28.9789 23.6711 28.8031 23.2304 28.5269 22.9435C28.2527 22.6586 27.8336 22.4776 27.2125 22.444C27.0194 22.4336 26.8714 22.2686 26.8819 22.0756Z"
                                  fill="white"/>
                            <path fill-rule="evenodd" clip-rule="evenodd"
                                  d="M26.4048 20.1565C26.42 19.9638 26.5886 19.8199 26.7813 19.8351C28.2459 19.9507 29.4381 20.4568 30.3185 21.4172L30.319 21.4177C31.1563 22.3348 31.5885 23.5273 31.5493 24.897C31.5438 25.0902 31.3827 25.2424 31.1895 25.2368C30.9963 25.2313 30.8441 25.0702 30.8496 24.877C30.884 23.6749 30.5079 22.6629 29.8023 21.89C29.066 21.0869 28.0538 20.6377 26.7262 20.5329C26.5335 20.5177 26.3896 20.3492 26.4048 20.1565Z"
                                  fill="white"/>
                            <path fill-rule="evenodd" clip-rule="evenodd"
                                  d="M25.7056 18.3837C25.7056 18.1904 25.8623 18.0337 26.0556 18.0337C28.1257 18.0337 29.8682 18.7271 31.2598 20.0801C32.6614 21.4428 33.3866 23.3028 33.3866 25.6219C33.3866 25.8152 33.2299 25.9719 33.0366 25.9719C32.8433 25.9719 32.6866 25.8152 32.6866 25.6219C32.6866 23.4584 32.0156 21.7912 30.7718 20.582C29.518 19.363 27.9537 18.7337 26.0556 18.7337C25.8623 18.7337 25.7056 18.577 25.7056 18.3837Z"
                                  fill="white"/>
                            <path d="M27.3049 29.0385C27.3049 29.0385 27.8192 29.0752 28.0764 28.7446L28.5908 28.0832C28.848 27.7526 29.4358 27.5321 30.0604 27.8628C30.3911 28.0465 30.9789 28.4139 31.3463 28.7078C31.7505 29.0018 32.5588 29.6631 32.5588 29.6631C32.9629 29.9938 33.0364 30.4714 32.7792 30.9858C32.522 31.4634 32.1546 31.9043 31.677 32.3084C31.3096 32.6391 30.9422 32.786 30.5748 32.8595H30.4278C30.2808 32.8595 30.0971 32.8228 29.9502 32.786C29.3991 32.6391 28.4806 32.2349 26.9007 31.3899C25.9087 30.8388 25.0637 30.2509 24.3656 29.6998C23.9982 29.4059 23.594 29.0752 23.2266 28.6711L23.0797 28.5241C22.6755 28.12 22.3449 27.7526 22.0509 27.3852C21.4998 26.6871 20.912 25.8421 20.3609 24.8501C19.5158 23.307 19.1117 22.3884 18.9647 21.8006C18.928 21.6536 18.8912 21.5067 18.8912 21.323V21.176C18.928 20.8086 19.1117 20.4412 19.4423 20.0738C19.8465 19.6329 20.2874 19.2655 20.765 18.9716C21.2794 18.7144 21.757 18.7879 22.0877 19.192C22.0877 19.192 22.749 20.0003 23.0429 20.4045C23.3001 20.7719 23.6675 21.3597 23.888 21.6904C24.2186 22.2782 23.9982 22.9028 23.7043 23.16L23.0429 23.6744C22.7123 23.9316 22.749 24.4459 22.749 24.4459C22.749 24.4459 23.6675 28.0832 27.3049 29.0385Z"
                                  fill="white"/>
                        </g>
                        <defs>
                            <clipPath id="clip0_0_1335">
                                <rect width="26.5334" height="28" fill="white" transform="translate(13 13)"/>
                            </clipPath>
                        </defs>
                    </svg>
                </a>
                <a href="#">
                    <svg width="52" height="52" viewBox="0 0 52 52" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <rect x="52" y="52" width="52" height="52" rx="12" transform="rotate(-180 52 52)"
                              fill="#015AB4"/>
                        <g clip-path="url(#clip0_0_1345)">
                            <path d="M17.3763 27.6752L20.3613 35.1371L24.2474 31.2511L30.9102 36.5469L35.6016 15.4531L11.6016 25.45L17.3763 27.6752ZM28.7435 21.5051L21.3975 28.2055L20.4825 31.6539L18.7923 27.4275L28.7435 21.5051Z"
                                  fill="white"/>
                        </g>
                        <defs>
                            <clipPath id="clip0_0_1345">
                                <rect width="24" height="24" fill="white" transform="translate(11.6016 14)"/>
                            </clipPath>
                        </defs>
                    </svg>
                </a>
                <a href="https://www.linkedin.com/company/smt-ua-com" target="_blank">
                    <svg width="52" height="52" viewBox="0 0 52 52" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <rect x="52" y="52" width="52" height="52" rx="12" transform="rotate(-180 52 52)"
                              fill="#015AB4"/>
                        <g clip-path="url(#clip0_0_1349)">
                            <path d="M19.5866 19.7209H14.7686C14.5547 19.7209 14.3815 19.8943 14.3815 20.108V35.5863C14.3815 35.8002 14.5547 35.9734 14.7686 35.9734H19.5866C19.8004 35.9734 19.9737 35.8002 19.9737 35.5863V20.108C19.9737 19.8943 19.8004 19.7209 19.5866 19.7209Z"
                                  fill="white"/>
                            <path d="M17.1793 12.0264C15.4262 12.0264 14 13.451 14 15.2022C14 16.9541 15.4262 18.3793 17.1793 18.3793C18.931 18.3793 20.3561 16.954 20.3561 15.2022C20.3561 13.451 18.931 12.0264 17.1793 12.0264Z"
                                  fill="white"/>
                            <path d="M31.8416 19.3363C29.9065 19.3363 28.476 20.1682 27.6084 21.1134V20.1081C27.6084 19.8943 27.4351 19.721 27.2213 19.721H22.6072C22.3934 19.721 22.2201 19.8943 22.2201 20.1081V35.5864C22.2201 35.8002 22.3934 35.9735 22.6072 35.9735H27.4147C27.6285 35.9735 27.8018 35.8002 27.8018 35.5864V27.9282C27.8018 25.3476 28.5028 24.3422 30.3017 24.3422C32.2608 24.3422 32.4165 25.954 32.4165 28.061V35.5865C32.4165 35.8003 32.5898 35.9736 32.8036 35.9736H37.6129C37.8268 35.9736 38 35.8003 38 35.5865V27.0964C38 23.2591 37.2683 19.3363 31.8416 19.3363Z"
                                  fill="white"/>
                        </g>
                        <defs>
                            <clipPath id="clip0_0_1349">
                                <rect width="24" height="24" fill="white" transform="translate(14 12)"/>
                            </clipPath>
                        </defs>
                    </svg>
                </a>
            </div>
        </div>
    </div>
</template>

<script>

import FooterLogoImg from "../assets/images/svg/footerLogoImg.vue";

export default {
    name: "SiteFooter",
    components: {FooterLogoImg}
}
</script>

<style lang="scss">
.footer {
  padding: 64px 0 83px 0;
  box-sizing: border-box;
  position: relative;

  @media (max-width: 1079px) {
    padding: 48px 0 120px 0;

  }

  &-bg {
    position: absolute;
    bottom: 0;
    width: 100%;
    left: 0;
    right: 0;
    margin: 0 auto;
    height: auto;
    max-height: 800px;
    overflow: hidden;

    svg {
      width: 100%;
      height: auto;
    }

    &_desktop {
      @media (max-width: 1079px) {
        display: none;
      }
    }

    &_mobile {
      display: none;

      @media (max-width: 1079px) {
        display: block;
      }
    }
  }

  &_block {
    max-width: 1144px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    padding: 0;

    @media (max-width: 1079px) {
      flex-direction: column;
    }
  }

  &_contacts {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-around;
    width: 100%;
    max-width: 652px;

    @media (max-width: 1079px) {
      flex-direction: column-reverse;
      align-items: center;
      margin-bottom: 24px;
      margin-top: 20px;
    }

    &--item {
      display: flex;
      flex-direction: row;
      align-items: center;
      gap: 8px;
      border-radius: 6px;
      padding: 4px 12px 4px 6px;
      cursor: pointer;
      transition: all .3s ease-in-out;

      &:hover {
        background: rgba(0, 127, 255, 0.08);
      }

      @media (max-width: 1079px) {
        .icon-hide {
          display: none;
        }
      }

      .desc {
        max-width: 252px;
        width: 100%;
        color: #015AB4;
        font-size: 14px;
        font-style: normal;
        font-weight: 500;
        line-height: 20px;
        letter-spacing: -0.28px;

        @media (max-width: 1079px) {
          text-align: center;
        }
      }
    }
  }

  &_socials {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    gap: 8px;

    a {
      cursor: pointer;
      height: 52px;

        svg {
            rect {
                transition: all .3s ease-in-out;
            }
        }

        &:hover {
            svg {
                rect {
                    fill: #014F9E;
                }
            }
        }
    }
  }
}


</style>
